export default __webpack_public_path__ + "static/media/az_players_club_logo.7cd7d8a9.svg";